import { CrmHealthCheck } from '@monetize/types/app';
import { useGetCrmHealthCheck } from '../../../../api/settingsService';

export type CrmConnectionHealth =
  | { status: 'checking' }
  | { status: 'healthy' }
  /** The connector reached the CRM and was rejected (e.g. a revoked token). */
  | { status: 'unhealthy'; errorDescription?: string }
  /** The healthcheck request itself failed, so health is not known. */
  | { status: 'unknown' };

export const toCrmConnectionHealth = (
  healthCheck: CrmHealthCheck | undefined,
  isError: boolean,
): CrmConnectionHealth => {
  // Checked before `healthCheck`: a failed refetch keeps the previous data.
  if (isError) {
    return { status: 'unknown' };
  }
  if (!healthCheck) {
    return { status: 'checking' };
  }
  if (healthCheck.error) {
    return {
      status: 'unhealthy',
      errorDescription: healthCheck.error.errorDescription,
    };
  }
  return { status: 'healthy' };
};

export const useCrmConnectionHealth = ({ enabled }: { enabled: boolean }) => {
  const { data, isError, refetch } = useGetCrmHealthCheck({ enabled });

  const recheck = async () => {
    const result = await refetch();
    return toCrmConnectionHealth(result.data, result.isError);
  };

  return { health: toCrmConnectionHealth(data, isError), recheck };
};
